module.exports = __webpack_public_path__ + "static/media/logo-dentalhouse.a990b654.png";